import {
    Checkbox,
    CommandBarButton, DefaultButton,
    DetailsList,
    IColumn, IconButton, IContextualMenuItem, IContextualMenuProps, MessageBarType, Modal,
    TooltipOverflowMode,
    Pivot,
    PivotItem, PrimaryButton,
    SelectionMode,
    Spinner,
    Stack,
    StackItem, TextField
} from "@fluentui/react";
import styles from "./POISearchScenarios.module.css"
import React, { useEffect, useState } from "react";
import { _legalColumns, _naturalColumns, Tab, ColumnFieldName } from "./POISearchScenariosUtils";
import { useId } from "@fluentui/react-hooks";
import strings from "../../../loc/strings";
import Pagination from "../../Pagination/Pagination";
import { IDropdownOption } from "@fluentui/react/lib/Dropdown";
import { LEGAL_PERSON_TYPE, NATURAL_PERSON_TYPE, SORT_ORDER_ASC } from "../../../constants/EiopaFnPConstants";
import {
    addSearchScenario,
    deleteSearchScenario, editSearchScenario,
    fetchLegalSearchScenarios,
    fetchNaturalSearchScenarios
} from "../../../services/AdminServices/SearchScenariosService";
import { useAuth } from "react-oidc-context";
import EiopaFnPIcons from "../../EiopaFnPIcons/EiopaFnPIcons";
import { Checkmark20Filled } from "@fluentui/react-icons";
import { SearchScenariosResult } from "../../../model/SearchScenariosResult";
import { copySearchScenario, POISearchScenario } from "../../../model/POISearchScenario";
import { displayMessageBar } from "../../LayoutWithAuth/LayoutWithAuth";
import {
    HTTP_STATUS_BAD_REQUEST,
    HTTP_STATUS_CONFLICT,
    HTTP_STATUS_OK
} from "../../../constants/HttpStatusCodes";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

interface POISearchScenariosState {
    isLoading: boolean
    selectedTab: string
    currentPage: number
    itemsPerPage: number
    columnsState: IColumn[]
    searchScenarios: POISearchScenario[]
    totalScenarios: number
    bool: boolean
    isAddModalOpen: boolean
    isDeleteModalOpen: boolean
    isAddVerificationModalOpen: boolean
    selectedScenario: POISearchScenario
}

function POISearchScenarios() {
    const auth = useAuth();
    const [state, setState] = useState<POISearchScenariosState>({
        isLoading: true,
        selectedTab: Tab.Natural,
        columnsState: _naturalColumns,
        searchScenarios: [],
        currentPage: 1,
        itemsPerPage: 10,
        totalScenarios: 0,
        bool: false,
        isAddModalOpen: false,
        isDeleteModalOpen: false,
        isAddVerificationModalOpen: false,
        selectedScenario: new POISearchScenario(NATURAL_PERSON_TYPE)
    });

    useEffect(() => {
        (function () {
            fetchScenarios(state.selectedTab, state.currentPage, state.itemsPerPage, state.columnsState, auth.user?.id_token).then(
                (response) => {
                    setState({
                        ...state,
                        isLoading: false,
                        searchScenarios: response.scenarios,
                        totalScenarios: response.totalScenarios
                    });
                }
            ).catch();
        })();
        return () => { };
    }, [state.bool]);

    const getTabId = (itemKey: string) => { return `Selected_${itemKey}`; };

    const buttonId = useId('add-search-scenario-button');

    const _columns = state.columnsState;
    _columns.forEach((column: IColumn) => {
        column.onColumnClick = _onColumnClick;
        column.onRenderHeader = () => (
            <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={column.name}>{column.name}</TooltipHost>
        );
    });

    const handleTabClick = (item?: PivotItem) => {
        if (item) {
            if (item.props.itemKey! === state.selectedTab) {
                return;
            }
            let columns: IColumn[] = getColumnsByTabName(item.props.itemKey!);
            setState({
                ...state,
                isLoading: true,
                selectedTab: item.props.itemKey!,
                currentPage: 1,
                columnsState: columns,
                selectedScenario: { ...state.selectedScenario, poiType: item.props.itemKey! === Tab.Natural ? NATURAL_PERSON_TYPE : LEGAL_PERSON_TYPE },
                bool: !state.bool
            });
        }
    }

    function _onColumnClick(event: React.MouseEvent<HTMLElement>, column: IColumn) {
        let isSortedDescending = column.isSortedDescending;

        if (column.isSorted) {
            isSortedDescending = !isSortedDescending;
        }

        let columns = state.columnsState.map(col => {
            col.isSorted = col.key === column.key;
            if (col.isSorted) {
                col.isSortedDescending = isSortedDescending;
            }
            return col;
        });

        setState({
            ...state,
            isLoading: true,
            currentPage: 1,
            columnsState: columns,
            bool: !state.bool
        });

    }

    function _onPageChange(selectedItem: number) {
        setState({
            ...state,
            isLoading: true,
            currentPage: selectedItem,
            bool: !state.bool
        });
    }

    function _onChangeItemsPerPage(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) {
        setState({
            ...state,
            isLoading: true,
            itemsPerPage: item.key as number,
            currentPage: 1,
            bool: !state.bool
        });
    }

    function _onRenderDeleteIcon() {
        return <EiopaFnPIcons iconName={"delete"} iconColor={"#0078D4"} />
    }

    function _onRenderActionsIcon() {
        return <EiopaFnPIcons iconName={"actions"} iconColor={"#0078D4"} />;
    }

    function _onRenderActionsMenuIcon() {
        return <></>;
    }

    function searchScenariosAction(item: POISearchScenario): IContextualMenuItem[] {
        return [
            {
                key: 'edit',
                text: 'Edit',
                iconProps: { iconName: 'EditSolid12', color: "blue" },
                onClick: () => setState({ ...state, isAddModalOpen: true, selectedScenario: copySearchScenario(item) }),
                target: '_blank',
                rel: 'opener'
            },
            {
                key: 'delete',
                text: 'Delete',
                onRenderIcon: () => _onRenderDeleteIcon(),
                onClick: () => setState({ ...state, isDeleteModalOpen: true, selectedScenario: item }),
            }
        ];
    }

    function _actionsButton(item: POISearchScenario) {

        const menuProps = (): IContextualMenuProps => {
            return {
                items: searchScenariosAction(item),
                directionalHintFixed: false,
                className: styles.actionsPanel
            } as IContextualMenuProps;
        };

        return (
            <IconButton
                menuProps={menuProps()}
                onRenderIcon={_onRenderActionsIcon}
                onRenderMenuIcon={_onRenderActionsMenuIcon}
                title="Actions"
                ariaLabel="Actions"
                className="actions-button"
            />
        )
    }

    function _renderItemColumn(item?: POISearchScenario, index?: number, column?: IColumn) {
        if (item && column) {
            const fieldContent = item[column.fieldName as keyof POISearchScenario] as string;

            switch (column.fieldName) {
                case ColumnFieldName.ID:
                    return <span><b>{fieldContent}</b></span>;
                case ColumnFieldName.LastName:
                    return item.lastName ? <Checkmark20Filled style={{ color: '#107C10' }} /> : <></>
                case ColumnFieldName.FirstName:
                    return item.firstName ? <Checkmark20Filled style={{ color: '#107C10' }} /> : <></>
                case ColumnFieldName.AlsoKnownAs:
                    return item.alsoKnownAs ? <Checkmark20Filled style={{ color: '#107C10' }} /> : <></>
                case ColumnFieldName.DateOfBirth:
                    return item.dateOfBirth ? <Checkmark20Filled style={{ color: '#107C10' }} /> : <></>
                case ColumnFieldName.PlaceOfBirth:
                    return item.placeOfBirth ? <Checkmark20Filled style={{ color: '#107C10' }} /> : <></>
                case ColumnFieldName.IDNumber:
                    return item.idNumber ? <Checkmark20Filled style={{ color: '#107C10' }} /> : <></>
                case ColumnFieldName.LegalName:
                    return item.legalName ? <Checkmark20Filled style={{ color: '#107C10' }} /> : <></>
                case ColumnFieldName.LeiRegistration:
                    return item.leiRegistration ? <Checkmark20Filled style={{ color: '#107C10' }} /> : <></>
                case ColumnFieldName.SocialSecurityNumber:
                    return item.socialSecurityNumber ? <Checkmark20Filled style={{ color: '#107C10' }} /> : <></>
                case ColumnFieldName.CountryOfIncorporation:
                    return item.countryInc ? <Checkmark20Filled style={{ color: '#107C10' }} /> : <></>
                case ColumnFieldName.Actions:
                    return _actionsButton(item)
                default:
                    return <span>{fieldContent}</span>;
            }
        }
    }

    const _onRenderIDLabel = () => {
        return (
            <label
                className={styles.AddModalIDLabel}
                htmlFor="ID"
            >
                ID
            </label>
        );
    }

    const _onChangeFirstName = (ev?: (React.FormEvent<HTMLElement | HTMLInputElement> | undefined), checked?: boolean) => {
        if (checked !== undefined) {
            setState({
                ...state,
                selectedScenario: {
                    ...state.selectedScenario,
                    firstName: !state.selectedScenario.firstName
                }
            })
        }
    }

    const _onChangeLastName = (ev?: (React.FormEvent<HTMLElement | HTMLInputElement> | undefined), checked?: boolean) => {
        if (checked !== undefined) {
            setState({
                ...state,
                selectedScenario: {
                    ...state.selectedScenario,
                    lastName: !state.selectedScenario.lastName
                }
            })
        }
    }

    const _onChangeAlsoKnownAs = (ev?: (React.FormEvent<HTMLElement | HTMLInputElement> | undefined), checked?: boolean) => {
        if (checked !== undefined) {
            setState({
                ...state,
                selectedScenario: {
                    ...state.selectedScenario,
                    alsoKnownAs: !state.selectedScenario.alsoKnownAs
                }
            })
        }
    }

    const _onChangeDateOfBirth = (ev?: (React.FormEvent<HTMLElement | HTMLInputElement> | undefined), checked?: boolean) => {
        if (checked !== undefined) {
            setState({
                ...state,
                selectedScenario: {
                    ...state.selectedScenario,
                    dateOfBirth: !state.selectedScenario.dateOfBirth
                }
            })
        }
    }

    const _onChangePlaceOfBirth = (ev?: (React.FormEvent<HTMLElement | HTMLInputElement> | undefined), checked?: boolean) => {
        if (checked !== undefined) {
            setState({
                ...state,
                selectedScenario: {
                    ...state.selectedScenario,
                    placeOfBirth: !state.selectedScenario.placeOfBirth
                }
            })
        }
    }

    const _onChangeIDNumber = (ev?: (React.FormEvent<HTMLElement | HTMLInputElement> | undefined), checked?: boolean) => {
        if (checked !== undefined) {
            setState({
                ...state,
                selectedScenario: {
                    ...state.selectedScenario,
                    idNumber: !state.selectedScenario.idNumber
                }
            })
        }
    }

    const _onChangeSocialSecurityNumber = (ev?: (React.FormEvent<HTMLElement | HTMLInputElement> | undefined), checked?: boolean) => {
        if (checked !== undefined) {
            setState({
                ...state,
                selectedScenario: {
                    ...state.selectedScenario,
                    socialSecurityNumber: !state.selectedScenario.socialSecurityNumber
                }
            })
        }
    }

    const _onChangeLeiRegistration = (ev?: (React.FormEvent<HTMLElement | HTMLInputElement> | undefined), checked?: boolean) => {
        if (checked !== undefined) {
            setState({
                ...state,
                selectedScenario: {
                    ...state.selectedScenario,
                    leiRegistration: !state.selectedScenario.leiRegistration
                }
            })
        }
    }

    const _onChangeLegalName = (ev?: (React.FormEvent<HTMLElement | HTMLInputElement> | undefined), checked?: boolean) => {
        if (checked !== undefined) {
            setState({
                ...state,
                selectedScenario: {
                    ...state.selectedScenario,
                    legalName: !state.selectedScenario.legalName
                }
            })
        }
    }
    const _onChangeCountryInc = (ev?: (React.FormEvent<HTMLElement | HTMLInputElement> | undefined), checked?: boolean) => {
        if (checked !== undefined) {
            setState({
                ...state,
                selectedScenario: {
                    ...state.selectedScenario,
                    countryInc: !state.selectedScenario.countryInc
                }
            })
        }
    }

    function _handleDismiss() {
        setState({ ...state, isAddModalOpen: false });
    }

    function _onClickAdd() {
        if (state.selectedScenario.id) {
            editSearchScenario(state.selectedScenario, auth.user?.id_token).then((code) => {
                let messageBarType: MessageBarType;
                let message: string;
                if (code === HTTP_STATUS_OK) {
                    messageBarType = MessageBarType.success;
                    message = strings.messageBarScenarioUpdateSuccess;
                } else if (code === HTTP_STATUS_CONFLICT) {
                    messageBarType = MessageBarType.error;
                    message = strings.messageBarScenarioExistsError;
                } else if (code === HTTP_STATUS_BAD_REQUEST) {
                    messageBarType = MessageBarType.error;
                    message = strings.messageBarInvalidScenarioError;
                } else {
                    messageBarType = MessageBarType.error;
                    message = strings.messageBarInternalServerError;
                }
                displayMessageBar(messageBarType, message, false);
                if (code === HTTP_STATUS_OK) {
                    setState({
                        ...state,
                        isLoading: true,
                        currentPage: 1,
                        isAddVerificationModalOpen: false,
                        bool: !state.bool
                    });
                } else {
                    setState({
                        ...state,
                        isAddVerificationModalOpen: false
                    });
                }
            });
        } else {
            addSearchScenario(state.selectedScenario, auth.user?.id_token).then((code) => {
                let messageBarType: MessageBarType;
                let message: string;
                if (code === HTTP_STATUS_OK) {
                    messageBarType = MessageBarType.success;
                    message = strings.messageBarScenarioInsertSuccess;
                } else if (code === HTTP_STATUS_CONFLICT) {
                    messageBarType = MessageBarType.error;
                    message = strings.messageBarScenarioExistsError;
                } else if (code === HTTP_STATUS_BAD_REQUEST) {
                    messageBarType = MessageBarType.error;
                    message = strings.messageBarInvalidScenarioError;
                } else {
                    messageBarType = MessageBarType.error;
                    message = strings.messageBarInternalServerError;
                }
                displayMessageBar(messageBarType, message, false);
                if (code === HTTP_STATUS_OK) {
                    setState({
                        ...state,
                        isLoading: true,
                        currentPage: 1,
                        isAddVerificationModalOpen: false,
                        bool: !state.bool
                    });
                } else {
                    setState({
                        ...state,
                        isAddVerificationModalOpen: false
                    });
                }
            });
        }
    }

    function _onClickDelete() {
        deleteSearchScenario(state.selectedScenario, auth.user?.id_token).then((success) => {
            const messageBarType: MessageBarType = success ? MessageBarType.success : MessageBarType.error;
            const message: string = success ? strings.messageBarDeleteScenarioSuccess : strings.messageBarDeleteScenarioError;
            displayMessageBar(messageBarType, message, false);
            if (success) {
                setState({
                    ...state,
                    isDeleteModalOpen: false,
                    isLoading: true,
                    currentPage: 1,
                    bool: !state.bool
                })
            } else {
                setState({
                    ...state,
                    isDeleteModalOpen: false
                })
            }
        });
    }

    const addTooltipToColumnHeader = (cols: IColumn[]) => {
        const a = cols.map((column) => ({
            ...column,
            onRenderHeader: () => (
                <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={column.name}>{column.name}</TooltipHost>
            ),
        }))
        return cols;
    }

    return (
        <Stack>
            <StackItem className={styles.POISearchScenariosHeader}>
                POI search scenarios
            </StackItem>
            <StackItem>
                <Stack horizontal style={{ justifyContent: "space-between", alignItems: "center" }}>
                    <StackItem>
                        <Pivot
                            aria-label="Main body pivot"
                            selectedKey={state.selectedTab}
                            onLinkClick={handleTabClick}
                            headersOnly={true}
                            getTabId={getTabId}
                            linkFormat={"links"}
                        >
                            <PivotItem
                                itemKey={"natural"}
                                headerText={"Natural"}
                            />
                            <PivotItem
                                itemKey={"legal"}
                                headerText={"Legal"}
                            />
                        </Pivot>
                    </StackItem>
                    <StackItem>
                        <Stack horizontal>
                            <StackItem>
                                <CommandBarButton
                                    id={buttonId}
                                    text={strings.addSearchScenarioButtonText}
                                    iconProps={{ iconName: "Add" }}
                                    onClick={() => setState({ ...state, isAddModalOpen: true, selectedScenario: new POISearchScenario(state.selectedTab === Tab.Natural ? NATURAL_PERSON_TYPE : LEGAL_PERSON_TYPE) })}
                                />
                            </StackItem>
                        </Stack>
                    </StackItem>
                </Stack>
            </StackItem>
            <StackItem>
                {
                    state.isLoading ?
                        <Spinner label={"Waiting for results"} size={2} />
                        :
                        <Stack>
                            <StackItem>
                                <DetailsList
                                    selectionMode={SelectionMode.none}
                                    layoutMode={1}
                                    columns={addTooltipToColumnHeader(_columns)}
                                    items={state.searchScenarios}
                                    onRenderItemColumn={_renderItemColumn}
                                />
                            </StackItem>
                            <StackItem>
                                <Pagination
                                    currentPage={state.currentPage}
                                    onPageChange={_onPageChange}
                                    itemsPerPage={state.itemsPerPage}
                                    onChangeItemsPerPage={_onChangeItemsPerPage}
                                    totalItems={state.totalScenarios}
                                />
                            </StackItem>
                        </Stack>
                }
            </StackItem>
            <Modal
                isOpen={state.isAddModalOpen}
                onDismiss={_handleDismiss}
            >
                <Stack className={styles.AddModalContainer}>
                    <StackItem className={styles.AddModalTitleRow}>
                        <div>
                            {state.selectedScenario.id ?
                                <span className={styles.AddModalTitle}>
                                    Edit search scenario
                                </span>
                                :
                                <span className={styles.AddModalTitle}>
                                    Add search scenario
                                </span>
                            }
                        </div>
                        <IconButton
                            style={{ marginLeft: '40px' }}
                            iconProps={{ iconName: "Cancel" }}
                            ariaLabel="Close popup modal"
                            onClick={_handleDismiss}
                        />
                    </StackItem>
                    <StackItem>
                        <TextField
                            label="ID"
                            id="ID"
                            disabled
                            value={state.selectedScenario.id ? state.selectedScenario.id.toString() : "#####"}
                            onRenderLabel={_onRenderIDLabel}
                        />
                    </StackItem>
                    <StackItem className={styles.AddModalSubTitleContainer}>
                        <span className={styles.AddModalSubTitle}>
                            Select one or more criteria to define the successful search scenario.
                        </span>
                    </StackItem>
                    {state.selectedTab == Tab.Natural ?
                        <StackItem className={styles.AddModalCheckboxes}>
                            <Checkbox label="First name" checked={state.selectedScenario.firstName} onChange={_onChangeFirstName} />
                            <Checkbox label="Last name" checked={state.selectedScenario.lastName} onChange={_onChangeLastName} />
                            <Checkbox label="Also known as" checked={state.selectedScenario.alsoKnownAs} onChange={_onChangeAlsoKnownAs} />
                            <Checkbox label="Date of birth" checked={state.selectedScenario.dateOfBirth} onChange={_onChangeDateOfBirth} />
                            <Checkbox label="Place of birth" checked={state.selectedScenario.placeOfBirth} onChange={_onChangePlaceOfBirth} />
                            <Checkbox label="ID number" checked={state.selectedScenario.idNumber} onChange={_onChangeIDNumber} />
                            <Checkbox label="Social security number" checked={state.selectedScenario.socialSecurityNumber} onChange={_onChangeSocialSecurityNumber} />
                        </StackItem>
                        :
                        <StackItem className={styles.AddModalCheckboxes}>
                            <Checkbox label="Legal name" checked={state.selectedScenario.legalName} onChange={_onChangeLegalName} />
                            <Checkbox label="Also known as" checked={state.selectedScenario.alsoKnownAs} onChange={_onChangeAlsoKnownAs} />
                            <Checkbox label="LEI / Registration number" checked={state.selectedScenario.leiRegistration} onChange={_onChangeLeiRegistration} />
                            <Checkbox label="Country of incorporation" checked={state.selectedScenario.countryInc} onChange={_onChangeCountryInc} />
                        </StackItem>
                    }
                    <StackItem className={styles.AddModalButtons}>
                        <PrimaryButton text={state.selectedScenario.id ? "Save" : "Add"} onClick={() => { setState({ ...state, isAddModalOpen: false, isAddVerificationModalOpen: true }) }} />
                        <DefaultButton text="Cancel" onClick={_handleDismiss} />
                    </StackItem>
                </Stack>
            </Modal>
            <Modal
                isOpen={state.isDeleteModalOpen}
                onDismiss={() => setState({ ...state, isDeleteModalOpen: false })}
            >
                <Stack className={styles.DeleteModalContainer}>
                    <StackItem className={styles.DeleteModalTitleRow}>
                        <div>
                            <span className={styles.DeleteModalTitle}>
                                Delete scenario
                            </span>
                        </div>
                        <IconButton
                            style={{ marginLeft: '40px' }}
                            iconProps={{ iconName: "Cancel" }}
                            ariaLabel="Close popup modal"
                            onClick={() => setState({ ...state, isDeleteModalOpen: false })}
                            data-testid="delete-modal-close"
                        />
                    </StackItem>
                    <StackItem className={styles.DeleteModalTextRow}>
                        <span>
                            Search scenario with ID {state.selectedScenario.id} will be deleted. Are you sure you want to continue?
                        </span>
                    </StackItem>
                    <StackItem className={styles.DeleteModalButtons}>
                        <PrimaryButton text="Confirm" onClick={_onClickDelete} />
                        <DefaultButton text="Cancel" onClick={() => { setState({ ...state, isDeleteModalOpen: false }) }} />
                    </StackItem>
                </Stack>
            </Modal>
            <Modal
                isOpen={state.isAddVerificationModalOpen}
                onDismiss={_handleDismiss}
            >
                <Stack className={styles.AddModalContainer}>
                    <StackItem className={styles.AddModalTitleRow}>
                        <div>
                            {state.selectedScenario.id ?
                                <span className={styles.AddModalTitle}>
                                    Edit search scenario
                                </span>
                                :
                                <span className={styles.AddModalTitle}>
                                    Add search scenario
                                </span>
                            }
                        </div>
                        <IconButton
                            style={{ marginLeft: '40px' }}
                            iconProps={{ iconName: "Cancel" }}
                            ariaLabel="Close popup modal"
                            onClick={() => setState({ ...state, isAddVerificationModalOpen: false })}
                            data-testid="add-verification-close"
                        />
                    </StackItem>
                    <StackItem className={styles.DeleteModalTextRow}>
                        {state.selectedScenario.id ?
                            <span>
                                Search scenario with ID {state.selectedScenario.id} will be updated. Are you sure you want to continue?
                            </span>
                            :
                            <span>
                                You are about to add a new search scenario. Are you sure you want to continue?
                            </span>
                        }
                    </StackItem>
                    <StackItem className={styles.DeleteModalButtons}>
                        <PrimaryButton text="Confirm" onClick={_onClickAdd} />
                        <DefaultButton text="Cancel" onClick={() => { setState({ ...state, isAddVerificationModalOpen: false, isAddModalOpen: true }) }} />
                    </StackItem>
                </Stack>
            </Modal>
        </Stack>
    );
}

function getColumnsByTabName(selectedTabName: string): IColumn[] {
    switch (selectedTabName) {
        case Tab.Natural:
            return _naturalColumns;
        case Tab.Legal:
            return _legalColumns;
        default:
            return [];
    }
}

function fetchScenarios(selectedTabName: string, page: number, itemsPerPage: number, columns: IColumn[], token: string | undefined): Promise<SearchScenariosResult> {
    const scenariosForm = {
        itemsPerPage: itemsPerPage,
        page: page,
        sortOrder: SORT_ORDER_ASC
    }
    switch (selectedTabName) {
        case Tab.Natural:
            return fetchNaturalSearchScenarios(scenariosForm, token);
        case Tab.Legal:
            return fetchLegalSearchScenarios(scenariosForm, token);
        default:
            return Promise.resolve(new SearchScenariosResult());
    }
}

export default POISearchScenarios;